<template>
<div class="L_HeaderDesktop">
    <header class="G_BGColorWhite G_DisplayRowNowrap L_TSTHeaderHolder">
        <img :src="TSTHeaderLogo" class="L_TSTLogo" @click="SetSelectedComp('Home')" />
        <div class="G_HeadingFont G_DisplayRowNowrap L_HeadingRowHolder">
            <span class="G_DisplayRowNowrap L_HeadingRowItem" v-for="HeaderItem in TSTHeaderItems" :key="HeaderItem" v-html="HeaderItem" @click="SetSelectedComp(HeaderItem)">
            </span>
            <span class="G_DisplayRowNowrap L_HeadingRowItem">
                <span class="G_DisplayRowNowrap L_BasketHolder" @click="SetSelectedComp('Basket')">
                    <i class="fa fa-shopping-basket"></i>
                    <span class="L_BasketCount">
                        {{BasketCount}}
                    </span>
                </span>
            </span>
        </div>
    </header>
</div>

<div class="L_HeadingMobile" v-if="!MobileHeadingExpanded">
    <div class="L_HeadingMobileLogoHolder">
        <img :src="TSTHeaderLogo" class="L_TSTLogo" @click="SetSelectedComp('Home', true)" />
    </div>
    <div class="G_DisplayRowNowrap" :class="MobileHeading">
        <div class="G_DisplayRowNowrap G_HeadingFont L_BasketHolderMobile">
            <i class="fa fa-shopping-basket" @click="SetSelectedComp('Basket', true)"></i>
            &nbsp;
            <span class="L_BasketCount">
                {{BasketCount}}
            </span>
        </div>
        <div class="G_DisplayRowNowrap G_HeadingFont L_BurgerHolder">
            <i class="fa" @click="ExpandMobileMenu()" v-if="!MobileHeadingExpanded">&#xf0c9;</i>
        </div>
    </div>
</div>
<div class="G_DisplayRowNowrap L_HeadingMobileBurgerBasketHolderExpanded" v-else>
    <div class="G_DisplayColumnNowrap L_MobileHeadingItems">
        <span class="G_DisplayColumnNowrap G_HeadingFont L_HeadingRowItem" v-for="HeaderItem in TSTHeaderItems" :key="HeaderItem" v-html="HeaderItem" @click="SetSelectedComp(HeaderItem, true)">
        </span>
    </div>
    <div class="G_DisplayRowNowrap L_MobileCloseExpandedMenuHolder">
        <div class="G_DisplayColumnNowrap G_HeadingFont L_MobileCloseExpandedMenu ">
            <i class="fa" @click="CloseMobileMenu()" v-if="MobileHeadingExpanded">&#xf00d;</i>
        </div>
    </div>
</div>
</template>

<script>
import TSTLogo from '../../assets/images/logos/TSTLogo.png'

export default {
    emits: ["SetSelectedComp"],
    props: [
        'BasketCount'
    ],
    name: 'TSTHeader',
    data() {
        return {
            TSTHeaderLogo: TSTLogo,
            TSTHeaderItems: [
                'Home',
                'Shop',
                'Contact Us'
            ],
            MobileHeading: "L_HeadingMobileBurgerBasketHolder",
            MobileHeadingExpanded: false
        }
    },
    watch() {},
    methods: {
        SetSelectedComp(HeaderItem, IsMobile) {
            if (IsMobile) {
                this.MobileHeading = "L_HeadingMobileBurgerBasketHolder"
                this.MobileHeadingExpanded = false
            }

            this.$emit('SetSelectedComp', HeaderItem)
        },
        ExpandMobileMenu() {
            this.MobileHeading = "L_HeadingMobileBurgerBasketHolderExpanded"
            this.MobileHeadingExpanded = true
        },
        CloseMobileMenu() {
            this.MobileHeading = "L_HeadingMobileBurgerBasketHolder"
            this.MobileHeadingExpanded = false
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/GlobalCss.scss";

.L_HeaderDesktop {
    @include mobile() {
        display: none;
    }
}

.L_TSTHeaderHolder {
    font-size: 1vw;
    width: 100%;
    height: 18rem;
    align-items: center;
    border-bottom: #F3CBBB solid .2rem;

    @include mobile() {
        display: none;
    }
}

.L_TSTLogo {
    width: 15%;
    height: 80%;
    cursor: pointer;

    @include mobile() {
        padding-left: 1rem;
        width: 50%;
        height: 90%;
    }
}

.L_HeadingRowHolder {
    width: 75%;
    height: 20%;
    justify-content: space-around;
}

.L_HeadingRowItem {
    width: 15%;
    height: 100%;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    @include mobile() {
        width: 50%;
        height: 15%;
        align-items: flex-start;
        padding-left: 1rem;
    }
}

.L_HeadingRowItem:hover {
    color: #F3CBBB;
    text-decoration: underline;
    transition: 0.5s;
}

.L_HeadingRowItem:last-child:hover {
    text-decoration: none;
}

.L_BasketHolder {
    width: 35%;
    height: 100%;
    align-items: center;
    justify-content: space-around;
}

.L_BasketCount {
    font-size: 1.2rem;
}

.L_HeadingMobile {
    display: none;

    @include mobile() {
        display: flex;
        height: 8rem;
    }
}

.L_HeadingMobileLogoHolder {
    @include mobile() {
        width: 50%;
        height: 100%;
    }
}

.L_HeadingMobileBurgerBasketHolder {
    @include mobile() {
        width: 50%;
        height: 100%;
    }
}

.L_BasketHolderMobile {
    @include mobile() {
        width: 50%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }
}

.L_BurgerHolder {
    @include mobile() {
        width: 50%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }
}

.L_HeadingMobileBurgerBasketHolderExpanded {
    @include mobile() {
        height: 15rem;
        width: 100%;
        justify-content: space-between;
        animation: HeadingTransitionExpand .5s ease forwards;
    }
}

.L_MobileHeadingItems {
    @include mobile() {
        height: 100%;
        width: 90%;
        justify-content: space-around;
    }
}

.L_MobileCloseExpandedMenuHolder {
    @include mobile() {
        width: 10%;
        height: 100%;
        justify-content: center;
        // align-items: center;
        margin-top: 1rem;
    }
}

.L_MobileCloseExpandedMenu {
    @include mobile() {
        height: 100%;
        width: 50%;
        align-items: center;
    }
}

@keyframes HeadingTransitionExpand {
    0% {
        height: 8rem;
    }

    100% {
        height: 15rem;
    }
}
</style>
